import { render, staticRenderFns } from "./CustomerDiscountProducts.vue?vue&type=template&id=4705f4cc&"
import script from "./CustomerDiscountProducts.vue?vue&type=script&lang=js&"
export * from "./CustomerDiscountProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports